export default __webpack_public_path__ + "images/nydree-icons.5782abba5e435f0e7ea1d81045fd4e5d.svg";